import { render, staticRenderFns } from "./UpsellSalesCart.vue?vue&type=template&id=45258e28&"
import script from "./UpsellSalesCart.vue?vue&type=script&lang=js&"
export * from "./UpsellSalesCart.vue?vue&type=script&lang=js&"
import style0 from "./UpsellSalesCart.vue?vue&type=style&index=0&id=45258e28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports